import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export const LoadingSpinner = ({ size = "md", className }: LoadingSpinnerProps) => {
  const sizeClasses = {
    sm: "h-4 w-4 border-2",
    md: "h-8 w-8 border-3",
    lg: "h-12 w-12 border-4"
  };

  return (
    <div className="flex items-center justify-center">
      <div
        className={cn(
          "animate-spin rounded-full border-primary border-t-transparent",
          sizeClasses[size],
          className
        )}
      />
    </div>
  );
};

interface LoadingOverlayProps {
  message?: string;
}

/**
 * LoadingOverlay - Use sparingly! Blocks entire UI.
 * Prefer in-content loading states to keep header/nav visible.
 * @deprecated Consider using LoadingState or LoadingSpinner in content area instead
 */
export const LoadingOverlay = ({ message = "Aquecendo..." }: LoadingOverlayProps) => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center rounded-lg p-8">
        <LoadingSpinner size="lg" />
        {message && <p className="mt-4 text-sm text-muted-foreground">{message}</p>}
      </div>
    </div>
  );
};
